/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-view-off-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M19.337 9.787a10.25 10.25 0 00-3.58-4.656l2.993-3-.881-.881L1.25 17.869l.881.881 3.188-3.181A9.612 9.612 0 0010 16.875a10.431 10.431 0 009.337-6.662.625.625 0 000-.425zM10 14.063c-.861 0-1.7-.276-2.394-.787l1.144-1.131a2.5 2.5 0 003.394-3.394l1.131-1.131A4.056 4.056 0 0110 14.063zm-7.169-.43l3.125-3.126A4.275 4.275 0 015.937 10a4.069 4.069 0 014.557-4.031l2.362-2.357A8.994 8.994 0 0010 3.125 10.431 10.431 0 00.662 9.787a.625.625 0 000 .425 9.913 9.913 0 002.17 3.42z"/>'
  }
})
